import type { StationeryDesignGalleryFilterTagsFragment } from '../../DesignsGallery.graphql.generated';

const dynamicFacetOptionStrings = new Map<string, string>();
const dynamicFacetOptionStringToLabel = new Map<string, string>();

const CATEGORY_TO_FACET: Record<string, string> = {
  Colors: 'color',
  Styles: 'style',
};

export function prepareFacetOptions(tagDefs: StationeryDesignGalleryFilterTagsFragment[] = []) {
  for (const tagDef of tagDefs) {
    const { category, name, displayLabel } = tagDef;
    const facet = CATEGORY_TO_FACET[category ?? ''];
    if (!facet) continue;
    dynamicFacetOptionStrings.set(name, `${facet}:${name}`);
    dynamicFacetOptionStringToLabel.set(`${facet}:${name}`, displayLabel);
  }
}

export function mapToFacetOption(tags: string[]) {
  return tags.filter(tag => dynamicFacetOptionStrings.has(tag)).map(tag => dynamicFacetOptionStrings.get(tag)!);
}

export function mapToLabel(facetOption: string) {
  return dynamicFacetOptionStringToLabel.get(facetOption);
}
